import { render, staticRenderFns } from "./RoundedImage.vue?vue&type=template&id=67c36acd&"
import script from "./RoundedImage.vue?vue&type=script&lang=js&"
export * from "./RoundedImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports